
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic03On as ObiLogic03OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-03-on.js';
 
 
 

 
 export const ObiLogic03On = createComponent({
   react: React,
   tagName: 'obi-logic-03-on',
   elementClass: ObiLogic03OnElement,
   events: {
     
   }
  });
 
 